import { AdScriptBanner } from '@/components/AdScriptBanner';

export const AdsterraBannerLarge = () => {
  // 728x90 leaderboard banner ad
  return (
    <div className="overflow-x-auto">
      <div className="flex justify-center">
        <AdScriptBanner
          atKey="707edc136bb04563ad96bfe82ab57055"
          scriptSrc="https://yesterdaydefinitelycorrespondence.com/707edc136bb04563ad96bfe82ab57055/invoke.js"
          width={728}
          height={90}
        />
      </div>
    </div>
  );
};
